import React from 'react';
import { boissons } from '../../content/food';

const Drinks = ({ onglet }) => {
  return (
    <div className={onglet === 5 ? 'visible' : 'hidden'}>
      <div className="mx-5 my-14">
        {boissons.map((boisson) => (
          <div key={boisson.toString()} className="mb-2 grid  grid-cols-5 md:mx-60 md:text-lg">
            <p className="col-span-4 ">{boisson}</p>
            <p className="text-center">2€</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Drinks;
